import {
  ImportInitialDataTypeEnum,
  MedicalCodeControllerApi,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
interface ImportCatalogProps {
  type: ImportInitialDataTypeEnum; 
  xTENANTID?: string;
}


// this is used to import the catalog data from the admin side
export const useImportCatalogDataFromAdmin = () =>
  useMutationWithLoading(async (props: ImportCatalogProps) =>
    new MedicalCodeControllerApi(getConfigObject()).importInitialData(
      props.type,
      props.xTENANTID
    )
  );
